import { Component, Input } from '@angular/core';

/**
 * Form Section Component
 *
 * Groups related form fields with a title and optional description.
 * Provides consistent spacing and visual separation.
 *
 * Usage:
 * ```html
 * <app-form-section
 *   title="Contact Information"
 *   description="Enter your contact details below">
 *   <div class="row">
 *     <div class="col-md-6">
 *       <input type="text" formControlName="firstName">
 *     </div>
 *   </div>
 * </app-form-section>
 * ```
 */
@Component({
  selector: 'app-form-section',
  standalone: false,
  templateUrl: './form-section.component.html',
  styleUrl: './form-section.component.scss'
})
export class FormSectionComponent {
  /** Section title */
  @Input() title = '';

  /** Optional description text */
  @Input() description = '';

  /** Whether to show a divider line above */
  @Input() divider = false;

  /** Whether the section is collapsible */
  @Input() collapsible = false;

  /** Whether the section is expanded (only applies if collapsible) */
  @Input() expanded = true;

  /** Icon to display next to the title */
  @Input() icon = '';

  toggle(): void {
    if (this.collapsible) {
      this.expanded = !this.expanded;
    }
  }
}
